import { TransportOrderIdView } from '../../../models';
import { ListRange, SearchCriteriaBase } from '../../../../common/models';

export interface ShipmentTransportOrderMaterialModel {
  materialDescription: string;
  materialPN: string;
  quantity: number;
  weight: number;
}

export class ShipmentTransportOrderMaterialListSearchCriteria extends SearchCriteriaBase {
  transportOrderIdView: TransportOrderIdView;
  constructor(params?: Partial<ShipmentTransportOrderMaterialListSearchCriteria> | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
